<template>
    <div style="padding: 0 30px" v-loading="loading">
        <p style="margin: 5px 0">
            <template v-if="nameEditing && canEditName">
                <el-input v-model="nameEditValue" size="small" style="width: 240px; margin-right: 8px"
                          @blur="saveName" @keyup.enter="saveName" ref="nameInput"></el-input>
                <el-button type="primary" link size="small" @click="saveName">保存</el-button>
                <el-button type="primary" link size="small" @click="nameEditing = false">取消</el-button>
            </template>
            <template v-else>
                <b>{{ dashboard.name }}</b>
                <el-icon v-if="canEditName" style="margin-left: 6px; cursor: pointer; font-size: 14px" @click="startEditName">
                    <Edit/>
                </el-icon>
            </template>
        </p>
        <p style="margin: 5px 0;font-size: 12px" class="color-info">
            创建人：
            <user v-model="dashboard.user_id"></user>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            更新时间：{{ timestampToDate(dashboard.u_time) }}
        </p>
        <p v-if="canManageAdmin" style="margin: 5px 0; font-size: 12px" class="color-info">
            看板管理员：
            <template v-for="uid in (dashboard.admin_ids || [])" :key="uid">
                <user :modelValue="uid" style="margin-right: 4px"></user>
                <el-icon style="cursor: pointer; vertical-align: middle" @click="removeAdmin(uid)">
                    <Close/>
                </el-icon>
            </template>
            <el-select v-model="addAdminUserId" placeholder="添加管理员" filterable size="small"
                       style="width: 160px; margin-left: 4px" @change="addAdmin">
                <el-option v-for="u in adminCandidateList" :key="u.user_id" :label="u.nickname || u.name" :value="u.user_id"/>
            </el-select>
        </p>
        <div style="display: flex;margin-top: 10px;justify-content: space-between">
            <div class="dashboard-toolbar">
                <div v-if="show_date_range">
                    <date-range-picker v-model="form" @change="dateChange" ref="date"></date-range-picker>
                    <el-icon style="margin-left: 10px;cursor: pointer;" @click="closeDateRange">
                        <CloseBold/>
                    </el-icon>
                </div>
                <el-button icon="Calendar" v-else @click="showDate">
                    选择日期
                </el-button>
                <el-popover placement="bottom-start" trigger="click" width="520">
                    <template #reference>
                        <el-button :type="dashboardFilters.length ? 'primary' : ''">
                            全局筛选
                            <span v-if="dashboardFilters.length">({{ dashboardFilters.length }})</span>
                        </el-button>
                    </template>
                    <div class="dashboard-filter-panel">
                        <el-form label-position="top" size="small">
                            <el-form-item label="国家">
                                <country-selector v-model="globalFilterForm.country" width="100%" size="small"
                                                  collapse-tags wanted="ip_name"></country-selector>
                            </el-form-item>
                            <el-form-item label="版本">
                                <el-select v-model="globalFilterForm.app_version" multiple filterable collapse-tags
                                           clearable style="width: 100%">
                                    <el-option v-for="v in filters.app_version" :key="v" :value="v"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="生命周期">
                                <div style="display: flex; width: 100%">
                                    <el-select v-model="globalFilterForm.living_days.operator" style="width: 110px">
                                        <el-option value="="></el-option>
                                        <el-option value=">"></el-option>
                                        <el-option value=">="></el-option>
                                        <el-option value="<="></el-option>
                                        <el-option value="<"></el-option>
                                    </el-select>
                                    <number-input int-only v-model="globalFilterForm.living_days.value"
                                                  style="width: calc(100% - 170px)" width="100%"></number-input>
                                    <el-button text size="small" style="width: 60px"
                                               @click="globalFilterForm.living_days.value = null">清空</el-button>
                                </div>
                            </el-form-item>
                            <el-form-item label="设备类型">
                                <el-select v-model="globalFilterForm.device_category" multiple clearable collapse-tags
                                           style="width: 100%">
                                    <el-option v-for="v in filters.device_category" :key="v" :value="v"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="安装来源">
                                <el-select v-model="globalFilterForm.media_source" multiple filterable clearable
                                           collapse-tags style="width: 100%">
                                    <el-option v-for="v in filters.media_source" :key="v" :value="v"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="AB测Tag">
                                <el-input v-model="globalFilterForm.abtest_tag" clearable></el-input>
                            </el-form-item>
                        </el-form>
                        <div style="text-align: right">
                            <el-button size="small" @click="clearDashboardFilters">清空全部</el-button>
                        </div>
                    </div>
                </el-popover>
            </div>
            <div>
                <el-button :type="show_all_values ? 'primary' : ''" @click="show_all_values = !show_all_values">
                    {{ show_all_values ? '隐藏所有数值' : '显示所有数值' }}
                </el-button>
                <el-button type="success" @click="$refs.editor.open()" v-if="canEdit">添加组件
                </el-button>
                <el-dropdown trigger="click">
                    <el-button icon="MoreFilled" style="margin-left: 10px">更多设置</el-button>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item>
                                <div @click="$refs.dashboardEditor.open(dashboard)">
                                    <el-icon>
                                        <CopyDocument/>
                                    </el-icon>
                                    复制看板
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item :disabled="!canEdit">
                                <div v-if="dashboard.public" @click="updateDashboard">
                                    <el-icon>
                                        <Lock/>
                                    </el-icon>
                                    转为私有
                                </div>
                                <div v-else @click="updateDashboard">
                                    <el-icon>
                                        <Unlock/>
                                    </el-icon>
                                    公开看板
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item class="color-error" :disabled="!canDelete">
                                <div class="color-error" @click="removeDashboard">
                                    <el-icon>
                                        <Delete/>
                                    </el-icon>
                                    删除看板
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </div>
        <el-divider style="margin: 10px 0"></el-divider>
        <grid-layout :layout.sync="component_list" :is-resizable="canEdit">
            <grid-item v-for="c in component_list" :x="c.x" :y="c.y" :w="c.w" :h="c.h" :i="c.i" :min-h="c.minH"
                       :min-w="c.minW" drag-allow-from=".handle" @resized="resize(c)" @moved="update">
                <component-grid :component="c" :disabled="!canEdit" :metric-list="metric_list" :ref="c.id"
                                @view="$refs.editor.open(c, true)" @remove="remove(c)"
                                :date-range="date_range" :show-values="show_all_values"
                                :dashboard-filters="dashboardFilters"
                                @edit="$refs.editor.open(c)"></component-grid>
            </grid-item>
        </grid-layout>
    </div>
    <component-editor ref="editor" :metric-list="metric_list" @change="refresh" @submit="add"></component-editor>
    <dashboard-editor ref="dashboardEditor" @afterSave="switchNewDashboard"></dashboard-editor>
</template>

<script>
import axios from 'ts-axios-new';
import User from "../../../base/User";
import {timestampToDate} from "../../../libs/utils";
import ComponentGrid from "./ComponentGrid";
import ComponentEditor from "./ComponentEditor";
import DashboardEditor from "./DashboardEditor";
import DateRangePicker from "../../../base/DateRangePicker";
import {is_pm} from "../../../libs/permission";
import CountrySelector from "../../../base/CountrySelector";
import NumberInput from "../../../base/NumberInput";

export default {
    name: "GrowthDashboard",
    components: {NumberInput, CountrySelector, DateRangePicker, DashboardEditor, ComponentEditor, ComponentGrid, User},
    inject: ['growth'],
    data() {
        const now = Date.now();
        const t = 2;
        return {
            loading: false, metric_list: [], dashboard: {}, component_list: [],
            show_date_range: false, date_range: null, t,
            show_all_values: false,
            nameEditing: false,
            nameEditValue: '',
            addAdminUserId: '',
            dashboardFilters: [],
            filters: {
                app_version: [],
                media_source: [],
                device_category: ['mobile', 'tablet'],
            },
            globalFilterForm: {
                country: [],
                app_version: [],
                living_days: {operator: '=', value: null},
                device_category: [],
                media_source: [],
                abtest_tag: '',
            },
            form: {
                start: timestampToDate(now - (t + 7) * 24 * 3600 * 1000),
                end: timestampToDate(now - t * 24 * 3600 * 1000),
            }
        }
    },
    methods: {
        showDate() {
            this.show_date_range = true;
            this.$nextTick(_ => {
                this.$refs.date.focus();
            })
        },
        dateChange() {
            this.date_range = {...this.form};
            this.refreshComponents();
        },
        closeDateRange() {
            const now = Date.now();
            this.date_range = null;
            this.form = {
                start: timestampToDate(now - (this.$root.t + 7) * 24 * 3600 * 1000),
                end: timestampToDate(now - this.$root.t * 24 * 3600 * 1000),
            }
            this.refreshComponents();
            this.show_date_range = false;
        },
        emptyGlobalFilterForm() {
            return {
                country: [],
                app_version: [],
                living_days: {operator: '=', value: null},
                device_category: [],
                media_source: [],
                abtest_tag: '',
            };
        },
        applyDashboardFilters() {
            const filters = [];
            if (this.globalFilterForm.country.length) {
                filters.push({key: 'country', operator: 'in', values: [...this.globalFilterForm.country]});
            }
            if (this.globalFilterForm.app_version.length) {
                filters.push({key: 'app_version', operator: 'in', values: [...this.globalFilterForm.app_version]});
            }
            if (this.globalFilterForm.living_days.value !== null && this.globalFilterForm.living_days.value !== undefined && this.globalFilterForm.living_days.value !== '') {
                filters.push({
                    key: 'living_days',
                    operator: this.globalFilterForm.living_days.operator,
                    value: this.globalFilterForm.living_days.value,
                });
            }
            if (this.globalFilterForm.device_category.length) {
                filters.push({key: 'device_category', operator: 'in', values: [...this.globalFilterForm.device_category]});
            }
            if (this.globalFilterForm.media_source.length) {
                filters.push({key: 'media_source', operator: 'in', values: [...this.globalFilterForm.media_source]});
            }
            if ((this.globalFilterForm.abtest_tag || '').trim()) {
                filters.push({key: 'abtest_tag', operator: 'like', value: this.globalFilterForm.abtest_tag.trim()});
            }
            if (JSON.stringify(filters) === JSON.stringify(this.dashboardFilters)) {
                return;
            }
            this.dashboardFilters = filters;
            this.refreshComponents();
        },
        clearDashboardFilters() {
            this.globalFilterForm = this.emptyGlobalFilterForm();
        },
        loadFilterOptions() {
            axios.all([
                axios.get('/api/v1/ua/channel').then(res => {
                    this.filters.media_source = ['Organic'];
                    res.data.data.channelList.forEach(c => {
                        if (c.media_source) {
                            this.filters.media_source.push(c.media_source);
                        }
                    })
                }),
                axios.get('/api/v1/pm/version', {params: {product_id: this.$route.params.productId}}).then(res => {
                    this.filters.app_version = [];
                    res.data.data.versionList.forEach(v => {
                        this.filters.app_version.push(v.version);
                    })
                })
            ])
        },
        refreshComponents() {
            this.$nextTick(_ => {
                this.component_list.forEach(c => {
                    const ref = this.$refs[c.id];
                    if (ref && ref[0]) {
                        ref[0].init();
                    }
                });
            })
        },
        switchNewDashboard(newBoard) {
            this.growth.data.push(newBoard);
            this.$router.push({name: 'PMGrowthDashboard', query: {dashboardId: newBoard.id}});
        },
        resize(component) {
            this.$nextTick(_ => {
                this.$refs[component.id].resize();
                this.update();
            })
        },
        update() {
            this.dashboard.layout = {};
            this.component_list.forEach(c => {
                this.dashboard.layout[c.id] = {
                    x: c.x,
                    y: c.y,
                    w: c.w,
                    h: c.h
                }
            });
            this.saveDashboard(this.dashboard);
        },
        saveDashboard(payload) {
            const body = {
                name: payload.name,
                public: payload.public,
                layout: payload.layout || {},
            };
            if (this.canManageAdmin) {
                body.admin_ids = payload.admin_ids !== undefined ? payload.admin_ids : (this.dashboard.admin_ids || []);
            }
            return axios.put(`/api/v1/growth/dashboard/${this.$route.query.dashboardId}`, body).then(res => {
                if (res.data && res.data.data) {
                    this.dashboard = Object.assign(this.dashboard, res.data.data);
                }
            });
        },
        startEditName() {
            this.nameEditValue = this.dashboard.name || '';
            this.nameEditing = true;
            this.$nextTick(() => this.$refs.nameInput?.focus());
        },
        saveName() {
            const name = (this.nameEditValue || '').trim();
            if (!name) return;
            this.loading = true;
            this.saveDashboard({...this.dashboard, name}).then(() => {
                this.dashboard.name = name;
                this.nameEditing = false;
                this.loading = false;
            }).catch(() => { this.loading = false; });
        },
        addAdmin() {
            if (!this.addAdminUserId) return;
            const admin_ids = [...(this.dashboard.admin_ids || []), this.addAdminUserId];
            this.loading = true;
            this.saveDashboard({...this.dashboard, admin_ids}).then(() => {
                this.addAdminUserId = '';
                this.loading = false;
            }).catch(() => { this.loading = false; });
        },
        removeAdmin(uid) {
            const admin_ids = (this.dashboard.admin_ids || []).filter(id => id !== uid);
            this.loading = true;
            this.saveDashboard({ ...this.dashboard, admin_ids }).then(() => {
                this.dashboard.admin_ids = admin_ids;
                this.loading = false;
            }).catch(() => { this.loading = false; });
        },
        refresh(c) {
            if (c.category !== 'number') {
                if (c.w < 6) {
                    c.w = 6;
                }
                if (c.h < 2) {
                    c.h = 2;
                }
                this.update();
            }
            this.$refs[c.id].init();
            c.minW = c.category === 'number' ? 3 : 6;
            c.minH = c.category === 'number' ? 1 : 2;
        },
        add(c) {
            const position = this.getLastPosition();
            c.x = position.x;
            c.y = position.y;
            c.i = c.id;
            if (c.category === 'number') {
                c.w = 3;
                c.h = 1;
            } else {
                c.w = 6;
                c.h = 2;
            }
            if (c.x + c.w > 12) {
                c.x = 0;
                c.y++;
            }
            c.minW = c.category === 'number' ? 3 : 6;
            c.minH = c.category === 'number' ? 1 : 2;
            this.component_list.push(c);
        },
        getLastPosition() {
            let y = 0;
            let x = 0;
            let last = null;
            this.component_list.forEach(c => {
                if (c.y > y) {
                    y = c.y;
                    x = c.x + c.w;
                    last = c;
                } else if (c.y === y && c.x + c.w > x) {
                    x = c.x + c.w;
                    last = c;
                }
            });
            if (x === 12) {
                y += last.h;
                x = 0;
            }
            return {x, y};
        },
        updateDashboard() {
            this.loading = true;
            this.dashboard.public = !this.dashboard.public;
            axios.put(`/api/v1/growth/dashboard/${this.$route.query.dashboardId}`, this.dashboard).then(res => {
                this.loading = false;
            })
        },
        init() {
            this.component_list = [];
            this.loading = true;
            this.loadFilterOptions();
            axios.get(`/api/v1/metric`, {
                params: {
                    contain_preset: 1,
                    product_id: this.$route.params.productId,
                }
            }).then(res => {
                this.metric_list = res.data.data.models;
                axios.get(`/api/v1/growth/dashboard/${this.$route.query.dashboardId}`).then(res => {
                    this.dashboard = res.data.data;
                    const config = res.data.data.layout;
                    if (config) {
                        res.data.data.component_list.forEach(c => {
                            const component_config = config[c.id];
                            if (component_config) {
                                c.x = component_config.x;
                                c.y = component_config.y;
                                c.w = component_config.w;
                                c.h = component_config.h;
                            } else {
                                const p = this.getLastPosition();
                                c.x = p.x;
                                c.y = p.y;
                                if (c.category === 'number') {
                                    c.w = 3;
                                    c.h = 1;
                                } else {
                                    c.w = 6;
                                    c.h = 2;
                                }
                            }
                            c.minW = c.category === 'number' ? 3 : 6;
                            c.minH = c.category === 'number' ? 1 : 2;
                            this.component_list.push(c);
                        });
                    } else {
                        let x = 0, y = 0;
                        res.data.data.component_list.filter(f => f.category === 'number').forEach(c => {
                            c.x = x;
                            c.y = y;
                            c.w = 3;
                            c.h = 1;
                            x += c.w;
                            if (x === 12) {
                                x = 0;
                                y += 1;
                            }
                            c.minW = 3;
                            c.minH = 1;
                            this.component_list.push(c);
                        });
                        if (x > 0) {
                            x = 0;
                            y += 1;
                        }
                        res.data.data.component_list.filter(f => f.category !== 'number').forEach(c => {
                            c.x = x;
                            c.y = y;
                            c.w = 6;
                            c.h = 2;
                            x += c.w;
                            if (x === 12) {
                                x = 0;
                                y += 2;
                            }
                            c.minW = 6;
                            c.minH = 2;
                            this.component_list.push(c);
                        });
                    }
                    // 巨大的坑，必须有i
                    this.component_list.forEach(c => {
                        c.i = c.id;
                    });
                    document.title = `${this.$root.product.nickname}(${this.$root.product.platform}) ${(this.dashboard.name || '自定义看板')}`;
                    this.loading = false;
                });
            })
        },
        timestampToDate(timestamp) {
            return timestampToDate(timestamp);
        },
        remove(item) {
            this.$confirm('确定要删除该组件吗？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(_ => {
                this.loading = true;
                axios.delete(`/api/v1/growth/component/${item.id}`).then(_ => {
                    // this.component_list.splice(this.component_list.indexOf(item), 1);
                    // this.loading = false;
                    this.init();
                });
            }).catch(_ => {
            });
        },
        removeDashboard() {
            this.$confirm('确定要删除该看板吗？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(_ => {
                this.loading = true;
                axios.delete(`/api/v1/growth/dashboard/${this.$route.query.dashboardId}`).then(res => {
                    let target = -1;
                    this.growth.data.forEach((d, i) => {
                        if (d.id === this.$route.query.dashboardId) {
                            target = i;
                        }
                    });
                    this.growth.data.splice(target, 1);
                    if (this.growth.data.length) {
                        this.$router.push({query: {dashboardId: this.growth.data[0].id}});
                    } else {
                        this.$router.push({name: 'PMDashboard'})
                    }
                    this.loading = false;
                })
            }).catch(_ => {
            })
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        "$route.query.dashboardId"() {
            if (this.$route.query.dashboardId) {
                this.closeDateRange();
                this.clearDashboardFilters();
                this.init();
            }
        },
        globalFilterForm: {
            handler() {
                this.applyDashboardFilters();
            },
            deep: true,
        },
    },
    computed: {
        isCreator() {
            return this.dashboard.user_id === this.$root.user.user_id;
        },
        isAdmin() {
            return (this.dashboard.admin_ids || []).includes(this.$root.user.user_id);
        },
        canEdit() {
            return this.isCreator || this.isAdmin || is_pm();
        },
        canDelete() {
            return this.isCreator;
        },
        canManageAdmin() {
            return this.canEdit;
        },
        canEditName() {
            return this.canEdit;
        },
        adminCandidateList() {
            const list = this.$root.user_list || [];
            const creator = this.dashboard.user_id;
            const admins = this.dashboard.admin_ids || [];
            return list.filter(u => u.user_id !== creator && !admins.includes(u.user_id));
        },
    },
}
</script>

<style scoped>
.dashboard-toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
}

.dashboard-filter-panel ::v-deep(.el-form-item) {
    margin-bottom: 10px;
}
</style>
